import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';

import Header from '../../components/Header';
import Button from '../../components/Button';
import ContentWrapper from '../../components/ContentWrapper';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Footer from '../../components/Footer';
import ApplicationId from '../../components/ApplicationId';

// Configuration & Assets
import { useConfig } from '../../config/ConfigContext';
import imgPayment from '../../assets/images/payment-blue.svg';

const VerifyBank = (props) => {
  const config = useConfig();
  const { navigate, checkinData, params, searchParams } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);
  const key = searchParams.get('key');

  useEffect(() => {
    const workflowType = get(params, 'workflowType');

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  const handleButtonClick = (e) => {
    e.preventDefault();
    const { dispatch } = props;
    const workflowType = get(params, 'workflowType') || 'text2apply';

    setIsProgressVisible(true);
    dispatch(newNextAction({
      key,
      workflowType,
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  return (
    <Transition className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <ContentWrapper className="appIdVisible">
        <img src={imgPayment} alt="" />
        <h1>Verify Your Bank Account</h1>
        <p>This is also the bank account you may use if you elect to set up auto-pay.</p>
      </ContentWrapper>
      <Footer>
        <FormRow>
          <FormColumn>
            <Button
              className="btn btn-primary arrow"
              onClick={handleButtonClick}
              title="Verify Bank Account"
            />
          </FormColumn>
        </FormRow>
      </Footer>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

VerifyBank.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(VerifyBank);
